/** Madrasah Al Islamiyyah Sunan Giri — libur rutin: Selasa & Kamis */

/** Parse "YYYY-MM-DD" into a local Date safely (avoid TZ shifts). */
export function parseDateLocal(dateStr) {
  if (!dateStr) return null;
  const parts = dateStr.split("-");
  if (parts.length !== 3) return null;
  return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
}

/** Returns true if the date is a school day (not Selasa/Kamis). */
export function isSchoolDay(dateStr) {
  const d = parseDateLocal(dateStr);
  if (!d) return true;
  const day = d.getDay(); // Sun=0, Mon=1, Tue=2, Wed=3, Thu=4, Fri=5, Sat=6
  return day !== 2 && day !== 4;
}

/** Returns "Selasa" / "Kamis" / null. */
export function getHolidayName(dateStr) {
  const d = parseDateLocal(dateStr);
  if (!d) return null;
  const day = d.getDay();
  if (day === 2) return "Selasa";
  if (day === 4) return "Kamis";
  return null;
}

export function todayISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export const HOLIDAY_MESSAGE =
  "Hari ini adalah hari libur Madrasah Al Islamiyyah Sunan Giri Surabaya. Absensi tidak perlu dilakukan.";
